import React from 'react';
import ReactDOM from 'react-dom';
import scriptLoader from 'react-async-script-loader';
import { withNamespaces } from 'react-i18next';
import { logError } from '../../../../../common/utils';
import { clone } from 'ramda';

const PayPal = (props) => {
  const {
    commit,
    onSuccess,
    onError,
    env,
    client,
    data = []
  } = props;

  const total = data.reduce((acc, val) => acc += val.total, 0);
  const subtotal = data.reduce((acc, val) => acc += val.sale_price, 0);
  const tax = data.reduce((acc, val) => acc += val.tax, 0);
  
  const paypal = window.PAYPAL;
  const payment = () =>
        paypal.rest.payment.create(env, client, {
          transactions: [
            {
              description: 'Robotex. Payment for ' + data.length + ' teams',
              amount: {
                total: total,
                currency: 'EUR',
                details: {
                  tax: tax,
                  subtotal: subtotal
                }
              }
            }
          ]
        });


  const handleCancel = () => {
    console.log('cancel');
  };

  const handleError = (err) => {
    onError(err);
  };

  const handleSuccess = (paymentData) => {
    onSuccess(paymentData, clone(data), total, subtotal, tax);
  };

  const onAuthorize = (data, actions) =>
        actions.payment.execute()
        .then(() => {
          const payment = {
            paid: true,
            cancelled: false,
            payerID: data.payerID,
            paymentID: data.paymentID,
            paymentToken: data.paymentToken,
            returnUrl: data.returnUrl
          };
          
          handleSuccess(payment);
        })
        .catch(logError);

  const PayPalButton = paypal ? paypal.Button.driver('react', { React, ReactDOM }) : null;
  
  return (
    PayPalButton &&
      <PayPalButton
        style={{
          size: 'responsive',
          color: 'blue',
          fundingicons: 'true'
        }}
        funding={{
          disallowed: [ paypal.FUNDING.CREDIT ]
        }}
        env={env}
        client={client}
        commit={commit}
        payment={payment}
        onAuthorize={onAuthorize}
        onCancel={handleCancel}
        onError={handleError} />
  );
};

export default scriptLoader('https://www.paypalobjects.com/api/checkout.js')(withNamespaces(['private'])(PayPal));



// WEBPACK FOOTER //
// ./src/private/user/components/Payment/PayPal/index.js